import { SelectionEntry } from './Library';

function makeSimplified(entry: SelectionEntry): SimplifiedSelectionEntry {
  const profiles = entry.profiles?.profile.map((p) => ({
    characteristics: p.characteristics.characteristic.map((c) => ({ 
      name: c._name,
      text: c.__text
    } as SimplifiedCharacteristic))
  } as SimplifiedProfile));

  const categoryLinks = entry.categoryLinks?.categoryLink.map((c) => ({
    name: c._name,
  } as SimplifiedCategoryLink));

  const constraints = entry.constraints?.constraint.map((c) => ({
    type: c._type,
    value: c._value,
  } as SimplifiedConstraint));

  return {
    name: entry._name,
    type: entry._type,
    profiles,
    categoryLinks,
    constraints,
    selectionEntries: []
  } as SimplifiedSelectionEntry;
}

function convertToSimplified(entry: SelectionEntry): SimplifiedSelectionEntry {
  const simplified = makeSimplified(entry);

  if(!entry.selectionEntries || entry.selectionEntries.selectionEntry.length == 0) {
    return simplified;
  }

  const output: SimplifiedSelectionEntry[] = [];

  entry.selectionEntries.selectionEntry.forEach((entry) => {
    output.push(convertToSimplified(entry));
  });

  return {
    ...simplified,
    selectionEntries: output
  } as SimplifiedSelectionEntry;
}

export function convertListToSimplified(entries: SelectionEntry[]): SimplifiedSelectionEntry[] {
  const output: SimplifiedSelectionEntry[] = [];

  entries.forEach((entry) => {
    output.push(convertToSimplified(entry));
  });

  return output;
}

export interface SimplifiedConstraint {
  type: string;
  value: string;
}

interface SimplifiedCharacteristic {
  name: string;
  text: string;
}

export interface SimplifiedProfile {
  characteristics: SimplifiedCharacteristic[];
}

interface SimplifiedCategoryLink {
  name: string;
}

export interface SimplifiedSelectionEntry {
  name: string;
  type: string;
  profiles?: SimplifiedProfile[];
  categoryLinks?: SimplifiedCategoryLink[];
  selectionEntries?: SimplifiedSelectionEntry[];
  constraints?: SimplifiedConstraint[];
}

export interface Catalogue {
  catalogue: { sharedSelectionEntries: { selectionEntry: SimplifiedSelectionEntry[] } };
}